var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"callout",class:[{ 'is-active' : _vm.expanded }, { 'hide-arrow' : _vm.arrow === false}, { 'is-left' : _vm.anchored == 'left' }, { 'is-right': _vm.anchored == 'right' }]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }